/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/3 11:06 上午
*/
export default {
    SET_TOKEN(state, token) {
        state.token = token;
    },
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo;
    },
    SET_IS_STORE(state, source) {
        state.isStore = source;
    },
    SET_PROJECT_CONFIG(state, projectConfig) {
        state.projectConfig = projectConfig;
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js